export default function formatScore(score: number | undefined | null, showNA?: boolean): string {
  if ((score === undefined || score === null) && showNA) {
    return 'N/A';
  }

  if (!score) {
    score = 0;
  }

  return score.toFixed(1);
}
